import { ActionHandler } from '../../../common/actions/core/action-handler';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { Action } from '../../../common/actions/core/action';
import { OpenDoubleOptTimeoutDialogAction } from './double-opt-timeout-dialog.action';

/*@ngInject*/
export default class OpenDoubleOptTimeoutDialogController
  implements ActionHandler {
  private dialogElement;

  private onResend: () => any;

  constructor(
    protected $element,
    protected actionDispatcher: ActionDispatcherService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element
      .find('#double-opt-timeout-dialog')
      .remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenDoubleOptTimeoutDialogAction) {
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenDoubleOptTimeoutDialogAction) {
    this.onResend = action.onResend;
    this.openDialog();
  }

  protected onResendCode() {
    this.onResend();
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/double-opt-dialog/timeout/double-opt-timeout-dialog.controller.ts